module.exports = __webpack_public_path__ + "static/media/logonav.240b4353.png";